import { render, staticRenderFns } from "./block-from-domains.vue?vue&type=template&id=c1affa70"
import script from "./block-from-domains.vue?vue&type=script&lang=js"
export * from "./block-from-domains.vue?vue&type=script&lang=js"
import style0 from "./block-from-domains.vue?vue&type=style&index=0&id=c1affa70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports